// opervex-frontend/src/services/ToastService.js

let listeners = [];

const ToastService = {
  register(cb) {
    listeners.push(cb);
  },

  unregister(cb) {
    listeners = listeners.filter((listener) => listener !== cb);
  },

  show({ messages, variant = "success", title = "", duration = 5000 }) {
    const toast = {
      id: Date.now() + Math.random(),
      messages,
      variant,
      title,
      duration,
    };

    listeners.forEach((cb) => cb(toast));
  },

  Success(messages, title = "Sucesso") {
    this.show({ messages, variant: "success", title });
  },

  Error(messages, title = "Erro") {
    this.show({ messages, variant: "danger", title });
  },

  Warning(messages, title = "Atenção") {
    this.show({ messages, variant: "warning", title });
  },

  Info(messages, title = "Informação") {
    this.show({ messages, variant: "info", title });
  },
};

export default ToastService;
